import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Modal, Spin } from "antd";
import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { PluginUpdateErrorNotice } from "./embed.js";
import { PluginUpdateForm } from "./form/form.js";
import { PluginUpdateLicenseList } from "./licenseList.js";
import { useStores } from "../../store/stores.js";
import { __ } from "../../utils/i18n.js";
const PluginUpdateModal = observer(()=>{
    const [doReloadAfterClose, setDoReloadAfterClose] = useState(false);
    const { pluginUpdateStore } = useStores();
    const { busy, modalPlugin, pluginUpdates, pluginUpdateFetchErrors } = pluginUpdateStore;
    const pluginUpdate = modalPlugin ? pluginUpdates.get(modalPlugin) : undefined;
    const showHeadline = pluginUpdate?.unlicensedEntries.length > 0 && pluginUpdate?.licensedEntries.length > 0;
    const handleCancel = useCallback(()=>{
        if (doReloadAfterClose) {
            const { checkUpdateLink } = pluginUpdate;
            if (checkUpdateLink) {
                window.location.href = checkUpdateLink;
            } else {
                window.location.reload();
            }
        } else {
            pluginUpdateStore.hideModal();
        }
    }, [
        doReloadAfterClose,
        pluginUpdateStore,
        pluginUpdate
    ]);
    const handleChange = useCallback(()=>setDoReloadAfterClose(true), [
        setDoReloadAfterClose
    ]);
    const error = pluginUpdateFetchErrors.get(modalPlugin);
    useEffect(()=>{
        document.body.classList[modalPlugin ? "add" : "remove"]("rpm-wpc-antd-modal-open");
    }, [
        modalPlugin
    ]);
    return modalPlugin ? /*#__PURE__*/ _jsx(Modal, {
        open: true,
        okButtonProps: {
            form: `license-form-${pluginUpdate?.slug}`,
            htmlType: "submit",
            style: {
                display: pluginUpdate?.unlicensedEntries.length === 0 || error ? "none" : undefined
            }
        },
        cancelButtonProps: {
            style: {
                display: "none"
            }
        },
        onCancel: handleCancel,
        okText: __("Save"),
        title: pluginUpdate ? /*#__PURE__*/ _jsxs("span", {
            style: {
                fontWeight: "normal"
            },
            children: [
                /*#__PURE__*/ _jsxs("strong", {
                    children: [
                        pluginUpdate.name,
                        ":"
                    ]
                }),
                " ",
                __("License settings")
            ]
        }) : "",
        width: 800,
        children: error ? /*#__PURE__*/ _jsx(PluginUpdateErrorNotice, {
            slug: modalPlugin
        }) : busy || !pluginUpdate ? /*#__PURE__*/ _jsx(Spin, {
            spinning: true
        }) : /*#__PURE__*/ _jsxs("div", {
            children: [
                showHeadline && /*#__PURE__*/ _jsx(Divider, {
                    type: "horizontal",
                    orientation: "left",
                    style: {
                        marginTop: 0
                    },
                    children: __("Not yet licensed")
                }),
                /*#__PURE__*/ _jsx(PluginUpdateForm, {
                    onSave: handleChange,
                    pluginUpdate: pluginUpdate
                }),
                showHeadline && /*#__PURE__*/ _jsx(Divider, {
                    type: "horizontal",
                    orientation: "left",
                    children: __("Already licensed")
                }),
                pluginUpdate.licensedEntries.length > 0 && /*#__PURE__*/ _jsx(PluginUpdateLicenseList, {
                    onDeactivate: handleChange,
                    pluginUpdate: pluginUpdate
                })
            ]
        })
    }) : null;
});
export { PluginUpdateModal };
